angular.module('CarsSaraBo').factory('CompanyRequestService', ['$resource', function($resource) {
  return $resource('../rest/companyRequest/:oid/', 
    { oid : '@oid' },
    {
        update : { method: 'PUT' },
        remove : { method: 'DELETE' }
    }
  )}
]);



//////////////////
// WEBPACK FOOTER
// ./public/app/models/company_request_service.js
// module id = 841
// module chunks = 3